import { Injectable } from '@angular/core';

declare var $: any;

export interface ButtonData {
    textBoton: string;
    enlaceBoton: string;
    class: string;
}

@Injectable({
  providedIn: 'root'
})
export class ModalAlternativeService {

  titulo: string = '';
  textoHTML: string = '';
  imgLateral: string = '';
  buttonDataList: ButtonData[] = [];
  alternativeMessage: string = '';

  typeModal: string = 'modal-confirm';

  constructor() { }

  close() {
    this.titulo = '';
    this.textoHTML = '';
    this.imgLateral = '';
    this.buttonDataList = [];
    this.alternativeMessage = '';
    $('#modal-alternative').modal('hide');
  }

  open(title: string, textHTML: string, imagen: string, buttonDataList: ButtonData[], alternativeMessage: string = '') {

    this.titulo = title;
    this.textoHTML = textHTML;
    this.imgLateral = imagen;
    this.buttonDataList = buttonDataList;
    this.alternativeMessage = alternativeMessage;

    $('#modal-alternative').modal({backdrop: 'static', keyboard: false});
  }

  redirect(url: string) {
    if (url !== '') {
      window.open(url, '_blank');
    }
  }
}
